import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import reportWebVitals from './reportWebVitals';
import { BrowserRouter, Route, Routes, Navigate, useLocation } from 'react-router-dom';
import { Provider } from 'react-redux';
import { store } from './admin/store';
import CringeIndex from './pages/cringe/CringeIndex';
import CringeStory from './pages/cringe/CringeStory';
import CringeStage1 from './pages/cringe/CringeStage1';
import CringeStage2 from './pages/cringe/CringeStage2';
import CringeStage3 from './pages/cringe/CringeStage3';
import CringeStage4 from './pages/cringe/CringeStage4';
import CringeStage5 from './pages/cringe/CringeStage5';
import CringeThankyou from './pages/cringe/CringeThankyou';

// Redirect to the landing page but keep ?otp=…&role=… / ?demo=… so a refresh can log in again.
function ToIndex() {
  const { search } = useLocation();
  return <Navigate to={{ pathname: '/', search }} replace />;
}

// Same flow as the PHP game: index -> story -> stage1 -> stage2 -> stage3 -> stage4 (PipeGame) -> stage5 -> thankyou
function App() {
  return (
    <Provider store={store}>
      <Routes>
        <Route index element={<CringeIndex />} />
        <Route path="/login" element={<ToIndex />} />
        <Route path="/story" element={<CringeStory />} />
        <Route path="/stage1" element={<CringeStage1 />} />
        <Route path="/stage2" element={<CringeStage2 />} />
        <Route path="/stage3" element={<CringeStage3 />} />
        <Route path="/stage4" element={<CringeStage4 />} />
        <Route path="/stage5" element={<CringeStage5 />} />
        <Route path="/thankyou" element={<CringeThankyou />} />
        <Route path="*" element={<ToIndex />} />
      </Routes>
    </Provider>
  );
}

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <BrowserRouter>
    <App />
  </BrowserRouter>
);

reportWebVitals();
